// src/data/projects.js

export const projects = [
  {
    id: 1,
    title: "Visión Nativa",
    description:
      "Serie documental fotográfica que explora la identidad, el territorio y la memoria en la Patagonia chilena. Un registro visual que entrelaza paisaje, comunidad y pertenencia a través de la cotidianidad de Chile Chico.",
    shortDescription: "Fotografía documental de identidad y territorio patagónico",

    // Técnicas y equipo utilizados
    technologies: [
      "Fotografía Documental",
      "Canon EOS R6",
      "Lightroom",
      "Photoshop",
      "Narrativa Visual",
    ],

    // Características principales
    features: [
      "Registro de memoria local",
      "Retratos comunitarios",
      "Paisajes patagónicos",
      "Narrativa autobiográfica",
      "Fotografía análoga y digital",
      "Edición de color cinematográfica",
    ],

    // Imágenes del proyecto
    images: {
      main: "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB3.jpg?alt=media&token=db6fe70b-11d3-4a7f-bd6f-ed7c65f9234b",
      thumbnail:
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB3.jpg?alt=media&token=db6fe70b-11d3-4a7f-bd6f-ed7c65f9234b",
      gallery: [
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB3.jpg?alt=media&token=db6fe70b-11d3-4a7f-bd6f-ed7c65f9234b",
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB7.jpg?alt=media&token=364403f7-3d0f-4144-b0ab-8ff7b49fd14d",
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB4.jpg?alt=media&token=26886a54-5475-4b43-b4c3-09dec02fe8c1",
      ],
    },

    // Enlaces
    links: {
      demo: "https://www.behance.net/gasenieurra",
      github: "https://www.instagram.com/chilechicano",
      figma: "https://www.behance.net/gasenieurra",
    },

    // Metadata
    status: "completed",
    featured: true,
    category: "documental",
    startDate: "2020",
    endDate: "2024",
  },

  {
    id: 2,
    title: "Raíces del Lago",
    description:
      "Ensayo fotográfico sobre la relación entre las familias pioneras y el Lago General Carrera. Un trabajo que documenta la vida cotidiana, las tradiciones y el vínculo profundo con el paisaje lacustre de la zona.",
    shortDescription: "Ensayo visual sobre comunidad y lago patagónico",

    technologies: ["Fotografía de Paisaje", "Nikon D850", "Filtros ND", "Edición RAW", "Fotografía Aérea"],

    features: [
      "Fotografía de paisaje patagónico",
      "Retratos de pescadores locales",
      "Tomas aéreas con drone",
      "Registro de tradiciones",
      "Composición minimalista",
      "Paleta de colores naturales",
    ],

    images: {
      main: "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB7.jpg?alt=media&token=364403f7-3d0f-4144-b0ab-8ff7b49fd14d",
      thumbnail:
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB7.jpg?alt=media&token=364403f7-3d0f-4144-b0ab-8ff7b49fd14d",
      gallery: [
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB7.jpg?alt=media&token=364403f7-3d0f-4144-b0ab-8ff7b49fd14d",
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB4.jpg?alt=media&token=26886a54-5475-4b43-b4c3-09dec02fe8c1",
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB8.jpg?alt=media&token=410a01de-dc93-4369-b0bc-71b30b37a6a1",
      ],
    },

    links: {
      demo: "https://www.behance.net/gasenieurra",
      github: "https://www.instagram.com/chilechicano",
    },

    status: "completed",
    featured: true,
    category: "paisaje",
    startDate: "2021",
    endDate: "2023",
  },

  {
    id: 3,
    title: "Cerros que Habitan",
    description:
      "Proyecto fotográfico que documenta la relación entre los habitantes de Chile Chico y las montañas que los rodean. Una exploración visual sobre cómo el paisaje define la identidad local.",
    shortDescription: "Fotografía sobre identidad y montaña patagónica",

    technologies: [
      "Fotografía Análoga",
      "Película 35mm",
      "Hasselblad",
      "Revelado Manual",
      "Escaneo de Alta Resolución",
    ],

    features: [
      "Fotografía análoga en película",
      "Retratos ambientales",
      "Texturas de montaña",
      "Blanco y negro expresivo",
      "Grano fotográfico orgánico",
      "Proceso artesanal completo",
    ],

    images: {
      main: "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB4.jpg?alt=media&token=26886a54-5475-4b43-b4c3-09dec02fe8c1",
      thumbnail:
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB4.jpg?alt=media&token=26886a54-5475-4b43-b4c3-09dec02fe8c1",
      gallery: [
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB4.jpg?alt=media&token=26886a54-5475-4b43-b4c3-09dec02fe8c1",
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB8.jpg?alt=media&token=410a01de-dc93-4369-b0bc-71b30b37a6a1",
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB3.jpg?alt=media&token=db6fe70b-11d3-4a7f-bd6f-ed7c65f9234b",
      ],
    },

    links: {
      demo: "https://www.behance.net/gasenieurra",
      github: "https://www.instagram.com/chilechicano",
      playstore: "https://www.behance.net/gasenieurra",
      appstore: "https://www.instagram.com/chilechicano",
    },

    status: "in-progress",
    featured: false,
    category: "retrato",
    startDate: "2023",
    endDate: null,
  },

  // Proyecto adicional de ejemplo
  {
    id: 4,
    title: "Horizonte Austral",
    description:
      "Colección de fotografías de paisajes de la Patagonia chilena capturados en diferentes estaciones del año. Un trabajo que explora la luz, el color y las texturas del fin del mundo.",
    shortDescription: "Fotografía de paisaje patagónico estacional",

    technologies: ["Fotografía de Paisaje", "Sony A7IV", "Capture One", "Tomas Largas Exposición", "HDR"],

    features: [
      "Paisajes de las cuatro estaciones",
      "Largas exposiciones",
      "Composición panorámica",
      "Procesado HDR natural",
      "Prints de gran formato",
      "Exhibición en galerías",
    ],

    images: {
      main: "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB8.jpg?alt=media&token=410a01de-dc93-4369-b0bc-71b30b37a6a1",
      thumbnail: "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB8.jpg?alt=media&token=410a01de-dc93-4369-b0bc-71b30b37a6a1",
      gallery: [
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB8.jpg?alt=media&token=410a01de-dc93-4369-b0bc-71b30b37a6a1",
        "https://firebasestorage.googleapis.com/v0/b/gasenieurra-c6b7c.firebasestorage.app/o/Fotografias%20portafolio%201%2FWEB3.jpg?alt=media&token=db6fe70b-11d3-4a7f-bd6f-ed7c65f9234b",
      ],
    },

    links: {
      demo: "https://www.behance.net/gasenieurra",
      github: "https://www.instagram.com/chilechicano",
    },

    status: "completed",
    featured: false,
    category: "paisaje",
    startDate: "2022",
    endDate: "2024",
  },
];

// Categorías de proyectos para filtros
export const projectCategories = [
  { id: "all", label: "Todos", count: projects.length },
  {
    id: "documental",
    label: "Documental",
    count: projects.filter((p) => p.category === "documental").length,
  },
  {
    id: "paisaje",
    label: "Paisaje",
    count: projects.filter((p) => p.category === "paisaje").length,
  },
  {
    id: "retrato",
    label: "Retrato",
    count: projects.filter((p) => p.category === "retrato").length,
  },
];

// Proyectos destacados (para mostrar en homepage)
export const featuredProjects = projects.filter((project) => project.featured);

// Función para obtener proyecto por ID
export const getProjectById = (id) => {
  return projects.find((project) => project.id === parseInt(id));
};

// Función para obtener proyectos por categoría
export const getProjectsByCategory = (category) => {
  if (category === "all") return projects;
  return projects.filter((project) => project.category === category);
};

export default projects;
